export default "__VITE_ASSET__DsyCVN3X__"